module.exports = __webpack_public_path__ + "img/goodvirtues.f0c015bb.jpg";